// sets next route location
export const reduceSetNextRouteLocation = (state, { payload } = {}) => ({
  ...state,
  nextRouteLocation: payload,
});
